import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { LeaderCriteriaResponse } from "~pages/LeaderCriteria/types/leaderCriteria.ts";

export const useFetchLeaderCriteria = (leaderCriteriaId?: string) => {
  const request = useApi();
  const { organizationId, sport } = useParams();

  return useQuery({
    queryKey: ["leaderCriteria", sport, organizationId, leaderCriteriaId],
    queryFn: () =>
      request<LeaderCriteriaResponse>(`${sport}/o/${organizationId}/statistics/leaders/criteria/${leaderCriteriaId}`).then(
        (response) => response?.data?.[0],
      ),
    enabled: !!leaderCriteriaId,
  });
};
